import NetworkStatusV2 from "./NetworkStatusV2";
export default NetworkStatusV2;
